import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DividerModule } from './../divider/divider.module';
import { PreventDragdropModule } from './../drag-and-drop/prevent-dragdrop.module';
import { IconModule } from './../icon/icon.module';
import { EmptyStateComponent } from './empty-state.component';

@NgModule({
  imports: [IconModule, CommonModule, DividerModule, PreventDragdropModule],
  declarations: [EmptyStateComponent],
  exports: [EmptyStateComponent],
})
export class EmptyStateModule {}
export { EmptyStateComponent } from './empty-state.component';
